module.exports = __webpack_public_path__ + "img/logo-USDT-tmp.bc4bdb62.svg";